import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=1de10e0a"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"
import style0 from "./edit.vue?vue&type=style&index=0&id=1de10e0a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./edit.vue?vue&type=custom&index=0&blockType=div&style=max-width%3A403px%3Bmax-height%3A300px"
if (typeof block0 === 'function') block0(component)

export default component.exports